<button
  class="btn btn-default assessment-notes-popover-button btn-xs"
  data-test-selector="notes-button"
  #p="ngbPopover"
  [ngbPopover]="commentPopover"
  [autoClose]="'outside'"
  (hidden)="onPopoverHidden()"
  container="body"
  placement="bottom auto"
>
  <i
    data-test-selector="button-icon"
    class="far fa-comment-alt-lines"
    *ngIf="!notes?.length"
  ></i>
  <i
    data-test-selector="button-icon"
    class="fas fa-comment-alt-lines"
    *ngIf="notes?.length"
  ></i>
</button>

<!--
  Popover
-->
<ng-template #commentPopover>
  <div
    class="assessment-notes-popover"
    data-test-selector="assessment-notes-popover"
  >
    <!--  Tabs -->
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item">
        <span
          class="nav-link"
          [ngClass]="{ active: activeTab === 1 }"
          (click)="activeTab = 1"
          data-target="#notes"
          data-toggle="tab"
          role="tab"
          aria-controls="notes"
          aria-selected="true"
          >Notes</span
        >
      </li>

      <li class="nav-item" *ngIf="canAddNotes">
        <span
          class="nav-link"
          [ngClass]="{ active: activeTab === 2 }"
          (click)="activeTab = 2"
          data-target="#add"
          data-toggle="tab"
          role="tab"
          aria-controls="add"
          aria-selected="false"
          >Add</span
        >
      </li>
    </ul>

    <!-- Tabs body-content -->
    <div class="tab-content">
      <!--
        Tab content - Note-List
      -->
      <div
        class="tab-pane fade show assessment-notes-tab-content"
        data-test-selector="assessment-notes-tab-content"
        *ngIf="activeTab === 1"
        [ngClass]="{ active: activeTab === 1 }"
        role="tabpanel"
        aria-labelledby="notes-tab"
      >
        <div
          data-test-selector="assessment-note"
          class="note"
          *ngFor="let note of notes"
        >
          <div class="note-header">
            <i class="fa fa-comment"></i>
            <span class="assessment-note-date text-muted">
              {{ note.auditInfo.createdDate | date: 'h:mm a M/d/yy' }}</span
            >
            <span class="assessment-note-email ellipsis text-muted">
              {{ note.auditInfo.createdBy }}</span
            >
          </div>
          <div>{{ note.note }}</div>
        </div>
      </div>

      <!--
        Tab content - Add-Note
      -->
      <div
        class="tab-pane fade show assessment-add-new-note-tab-content"
        *ngIf="canAddNotes && activeTab === 2"
        data-test-selector="assessment-add-note-tab-content"
        [ngClass]="{ active: activeTab === 2 }"
        role="tabpanel"
        aria-labelledby="add-tab"
      >
        <div class="content-wrapper">
          <!-- Dropdown Menu -->
          <div ngbDropdown class="dropdown-menu-wide" *ngIf="canUpdateOpinion && isOpinionDropdownVisible">
            <!-- Menu Toggle -->
            <button
              class="btn btn-outline-primary form-control-sm"
              data-test-selector="dropdown-menu-toggle-button"
              [disabled]="!crossReferenceOpinionOptions"
              ngbDropdownToggle
            >
              <span>
                <i
                  *ngIf="selectedOption"
                  class="fa"
                  [ngClass]="getIconClass(selectedOption)"
                ></i>
                {{ selectedOption?.feedback || defaultDropdown }}
              </span>
            </button>

            <!-- Menu items -->
            <div ngbDropdownMenu>
              <ng-container
                *ngFor="
                  let option of crossReferenceOpinionOptions;
                  let i = index;
                  let f = first
                "
              >
                <!-- divider for grouping by opinion types -->
                <div
                  class="dropdown-divider"
                  *ngIf="
                    !f &&
                    crossReferenceOpinionOptions &&
                    crossReferenceOpinionOptions[i - 1].opinion !==
                      option.opinion
                  "
                ></div>

                <!-- Selection item with icon -->
                <button
                  ngbDropdownItem
                  (click)="setSelectedOption(option)"
                  data-test-selector="option-item"
                >
                  <i class="fa" [ngClass]="getIconClass(option)"></i>
                  {{ option.feedback }}
                </button>
              </ng-container>

              <!-- Cancel Selection - item -->
              <ng-container *ngIf="selectedOption">
                <div class="dropdown-divider"></div>
                <button
                  ngbDropdownItem
                  class="text-muted"
                  (click)="setSelectedOption(undefined)"
                >
                  Cancel Selection
                </button>
              </ng-container>
            </div>
          </div>

          <!-- Note -->
          <textarea
            aria-label="New Note"
            data-test-selector="new-note-text-area"
            [(ngModel)]="noteMessage"
            placeholder="assessment note"
            class="form-control"
            rows="4"
          ></textarea>

          <!-- Apply / send button -->
          <button
            data-test-selector="apply-note-button"
            type="button"
            [disabled]="!(noteMessage || selectedOption)"
            class="btn btn-primary btn-sm float-end send-button"
            (click)="onClickApply(noteMessage, selectedOption)"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
